export * from 'server/models/VesselServiceSettings';


// WEBPACK FOOTER //
// ./data/models/VesselServiceSettings.ts